import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
// import { LoginComponent } from './components/login/login.component';
// import { CustomerLookupComponent } from './components/customer-lookup/customer-lookup.component';
// import { DisbursementOccurrencesComponent } from './components/disbursement-occurrences/disbursement-occurrences.component';
// import { DisbursementInvitationComponent } from './components/disbursement-invitation/disbursement-invitation.component';
import { SideNavComponent } from './navigation/components/side-nav/side-nav.component';

const routes: Routes = [

  {
    path: '',
    loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule),
  },
  {
    path: 'disbursements',
    children: [
      { path: '', loadChildren: () => import('./disbursements/disbursements.module').then(m => m.DisbursementsModule) }
    ],
    component: SideNavComponent
  }  

  // { path: '', pathMatch: 'full', redirectTo: 'home' },
  // { 
  //   path: 'login', 
  //   component: LoginComponent, 
  //   // canActivate: [authToken, requiredPrivilege], 
  //   // data: { privileges: ['PRIV_WD_DSB_OCCURRENCES_VIEW','PRIV_WD_PAYMENTS_MODIFY']}
  // }, 
  // { 
  //   path: 'acct', 
  //   component: CustomerLookupComponent, 
  //   // canActivate: [authToken, requiredPrivilege], 
  //   // data: { privileges: ['PRIV_WD_DSB_OCCURRENCES_VIEW','PRIV_WD_PAYMENTS_MODIFY']}
  // }, 
  // { 
  //   path: 'dsb-inv', 
  //   component: DisbursementInvitationComponent, 
  //   // canActivate: [authToken, requiredPrivilege], 
  //   // data: { privileges: ['PRIV_WD_DSB_OCCURRENCES_VIEW','PRIV_WD_PAYMENTS_MODIFY']}
  // },
  // { 
  //   path: 'dsb-ocr', 
  //   component: DisbursementOccurrencesComponent, 
  //   // canActivate: [authToken, requiredPrivilege], 
  //   // data: { privileges: ['PRIV_WD_DSB_OCCURRENCES_VIEW','PRIV_WD_PAYMENTS_MODIFY']}
  // } 
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})

export class AppRoutingModule {

 }
